export default __webpack_public_path__ + "static/media/ci2.9c03386c.png";